import * as Sentry from '@sentry/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import './index.css';
import router from '@configs/react-router';

const enableSentry =
	import.meta.env.MODE === 'production' || import.meta.env.MODE === 'staging';

if (enableSentry) {
	Sentry.init({
		dsn: import.meta.env.VITE_SENTRY_URI,
		integrations: [
			Sentry.browserTracingIntegration(),
			Sentry.replayIntegration(),
		],

		tracesSampleRate: +(import.meta.env.VITE_SENTRY_TRACE_RATE || 0.1),
		environment: import.meta.env.MODE,

		replaysSessionSampleRate: 0.1,
		replaysOnErrorSampleRate: 1.0,
	});
}

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
	<React.StrictMode>
		<QueryClientProvider client={queryClient}>
			<RouterProvider router={router} />
		</QueryClientProvider>
	</React.StrictMode>,
);
